// extracted by mini-css-extract-plugin
export default {"base":"Checkbox_base__dBbja","checkbox":"Checkbox_checkbox__CBakN","input":"Checkbox_input__mzfm7","box":"Checkbox_box__1M3yF","icon":"Checkbox_icon__wrbDK"};